module.exports = __webpack_public_path__ + "static/img/skb.c93966a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skb.png
// module id = nGH0
// module chunks = 0